import * as Types from '../../../../generated/graphql/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TalentSharedGetCurrentSessionQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TalentSharedGetCurrentSessionQueryQuery = { __typename?: 'Query', security: { __typename?: 'SecurityQuery', current_session?: { __typename?: 'UserSession', session_data: { [key: string]: any } } | null } };


export const TalentSharedGetCurrentSessionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TalentSharedGetCurrentSessionQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session_data"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useTalentSharedGetCurrentSessionQueryQuery__
 *
 * To run a query within a React component, call `useTalentSharedGetCurrentSessionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentSharedGetCurrentSessionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentSharedGetCurrentSessionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTalentSharedGetCurrentSessionQueryQuery(baseOptions?: Apollo.QueryHookOptions<TalentSharedGetCurrentSessionQueryQuery, TalentSharedGetCurrentSessionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentSharedGetCurrentSessionQueryQuery, TalentSharedGetCurrentSessionQueryQueryVariables>(TalentSharedGetCurrentSessionQueryDocument, options);
      }
export function useTalentSharedGetCurrentSessionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentSharedGetCurrentSessionQueryQuery, TalentSharedGetCurrentSessionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentSharedGetCurrentSessionQueryQuery, TalentSharedGetCurrentSessionQueryQueryVariables>(TalentSharedGetCurrentSessionQueryDocument, options);
        }
export type TalentSharedGetCurrentSessionQueryQueryHookResult = ReturnType<typeof useTalentSharedGetCurrentSessionQueryQuery>;
export type TalentSharedGetCurrentSessionQueryLazyQueryHookResult = ReturnType<typeof useTalentSharedGetCurrentSessionQueryLazyQuery>;
export type TalentSharedGetCurrentSessionQueryQueryResult = Apollo.QueryResult<TalentSharedGetCurrentSessionQueryQuery, TalentSharedGetCurrentSessionQueryQueryVariables>;